import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LandingPage from '../landing-page';
import { useAuthModal } from '../../contexts/AuthModalContext';

const LoginPage = () => {
  const location = useLocation();
  const { openAuthModal } = useAuthModal();

  useEffect(() => {
    openAuthModal('login', {
      redirectTo: location.state?.from || location.state?.redirect || '/dashboard',
    });
  }, [location.state, openAuthModal]);

  return <LandingPage />;
};

export default LoginPage;
